import React from "react";
import { ArrowDown, ArrowUp, Plus, Save } from "lucide-react";
import { apiTvwAlasanReject, formatApiErrorDetail } from "@/lib/api";
import { LAINNYA } from "@/lib/laporMasalah";

const inputCls = "rounded-lg border border-slate-700 bg-slate-950 px-2 py-1.5 text-sm text-slate-100";
const tombol = "inline-flex items-center gap-1.5 rounded-lg bg-amber-500 px-4 py-2 text-sm font-semibold text-slate-950 disabled:opacity-50";
const tombol2 = "inline-flex items-center rounded border border-slate-700 px-1.5 py-1 text-slate-300 hover:text-amber-300 disabled:opacity-40";

// v2.17 (owner 2026-10-22, requirement 75 butir 9d): the quick reasons of "Lapor masalah" and the QC reject —
// Owner only (the server checks). A reason is never deleted (old reports keep their meaning): rename it or
// switch it off; "Lainnya" is always active and last.
export default function AlasanRejectAtur({ awal, onSaved }) {
  const [rows, setRows] = React.useState(awal || []);
  const [busy, setBusy] = React.useState(false);
  const [pesan, setPesan] = React.useState(null);
  React.useEffect(() => { setRows(awal || []); }, [awal]);
  const ubah = (i, patch) => setRows(rows.map((r, x) => (x === i ? { ...r, ...patch } : r)));
  const geser = (i, d) => {
    const j = i + d;
    if (j < 0 || j >= rows.length - 1 || i >= rows.length - 1) return;  // "Lainnya" stays last
    const n = [...rows]; [n[i], n[j]] = [n[j], n[i]]; setRows(n);
  };
  const tambah = () => setRows([...rows.slice(0, -1), { kode: null, label: "", aktif: true }, rows[rows.length - 1]]);
  const simpan = async () => {
    setBusy(true); setPesan(null);
    try { await apiTvwAlasanReject(rows.map((r) => ({ kode: r.kode, label: r.label, aktif: r.aktif }))); setPesan({ ok: true, t: "Daftar alasan disimpan" }); onSaved(); }
    catch (e) { setPesan({ ok: false, t: formatApiErrorDetail(e.response?.data?.detail) || e.message }); }
    finally { setBusy(false); }
  };
  return (
    <section data-testid="atur-alasan-reject" className="space-y-3 rounded-xl border border-slate-800 bg-slate-900/60 p-4">
      <h2 className="font-semibold text-slate-100">Alasan reject / lapor masalah</h2>
      <p className="text-sm text-slate-400">Pilihan cepat untuk operator saat <b>Lapor masalah</b> dan untuk QC saat <b>Reject</b>. Alasan tidak bisa dihapus (laporan lama tetap terbaca) — ubah namanya atau matikan. &quot;Lainnya&quot; selalu ada dan wajib diisi keterangan.</p>
      <div className="space-y-2">
        {rows.map((r, i) => (
          <div key={r.kode || `baru-${i}`} data-testid={`atur-alasan-${r.kode || `baru-${i}`}`} className="flex flex-wrap items-center gap-2">
            <input data-testid={`atur-alasan-label-${i}`} value={r.label} maxLength={40} onChange={(e) => ubah(i, { label: e.target.value })} className={`${inputCls} w-56`} placeholder="nama alasan" />
            <label className="inline-flex items-center gap-1 text-xs text-slate-300">
              <input data-testid={`atur-alasan-aktif-${i}`} type="checkbox" checked={r.aktif} disabled={r.kode === LAINNYA} onChange={(e) => ubah(i, { aktif: e.target.checked })} /> aktif</label>
            {r.kode !== LAINNYA && <>
              <button type="button" aria-label="Naik" disabled={i === 0} onClick={() => geser(i, -1)} className={tombol2}><ArrowUp size={13} /></button>
              <button type="button" aria-label="Turun" disabled={i >= rows.length - 2} onClick={() => geser(i, 1)} className={tombol2}><ArrowDown size={13} /></button>
            </>}
            {!r.kode && <span className="text-xs text-amber-300">baru</span>}
          </div>
        ))}
      </div>
      {pesan && <div data-testid="atur-alasan-pesan" className={`rounded-lg border px-3 py-2 text-sm ${pesan.ok ? "border-emerald-500/30 bg-emerald-500/10 text-emerald-300" : "border-red-500/30 bg-red-500/10 text-red-300"}`}>{pesan.t}</div>}
      <div className="flex gap-2">
        <button data-testid="atur-alasan-tambah" type="button" onClick={tambah} disabled={rows.length >= 20} className="inline-flex items-center gap-1 rounded-lg border border-slate-700 px-3 py-2 text-sm text-slate-300 disabled:opacity-40"><Plus size={14} /> Tambah alasan</button>
        <button data-testid="atur-alasan-simpan" disabled={busy} onClick={simpan} className={tombol}><Save size={14} /> Simpan daftar alasan</button>
      </div>
    </section>
  );
}
